import { useAuth, useClerk } from "@clerk/react";

interface AttributeSetting {
  enabled?: boolean;
}

interface SignUpSetting {
  mode?: string;
}

interface ClerkSignUpSettings {
  __internal_environment?: {
    userSettings?: {
      attributes?: {
        emailAddress?: AttributeSetting;
        email_address?: AttributeSetting;
      };
      signUp?: SignUpSetting;
      sign_up?: SignUpSetting;
    };
  } | null;
  loaded: boolean;
}

export type SignUpMode = "public" | "waitlist" | "restricted";

const isSignUpMode = (mode: string | undefined): mode is SignUpMode =>
  mode === "public" || mode === "waitlist" || mode === "restricted";

/** Loaded sign-up mode, or null until Clerk has a usable email setting. */
export const useSignUpMode = (): SignUpMode | null => {
  const { isLoaded } = useAuth();
  const clerk = useClerk() as unknown as ClerkSignUpSettings;
  if (!(isLoaded && clerk.loaded)) {
    return null;
  }
  const settings = clerk.__internal_environment?.userSettings;
  const mode = settings?.signUp?.mode ?? settings?.sign_up?.mode;
  const emailEnabled =
    settings?.attributes?.emailAddress?.enabled ??
    settings?.attributes?.email_address?.enabled;
  if (emailEnabled !== true || !isSignUpMode(mode)) {
    return null;
  }
  return mode;
};
